// Groups My Day items (GET /api/search/my-day) into Overdue, Due today and
// Assigned to me, by deadline in the user's own time zone. Tasks always show
// up in exactly one group; list items only when they are overdue or due today.

// Titles and empty texts are translation keys: myDay.groups.<key>.title/empty
export const MY_DAY_GROUPS = [
  { key: "overdue", icon: "warning" },
  { key: "today", icon: "today" },
  { key: "assigned", icon: "assignment_ind" },
];

const DAY = 24 * 60 * 60 * 1000;

const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const daysFromToday = (deadline) =>
  Math.round((startOfDay(deadline) - startOfDay(new Date())) / DAY);

const getGroupKey = (item) => {
  if (item.deadline) {
    const days = daysFromToday(item.deadline);
    if (days < 0) return "overdue";
    if (days === 0) return "today";
  }
  return item.type === "task" ? "assigned" : null;
};

const compareItems = (a, b) => {
  // Earliest deadline first; items without a deadline last
  if (a.deadline !== b.deadline) {
    if (!a.deadline) return 1;
    if (!b.deadline) return -1;
    const diff = new Date(a.deadline) - new Date(b.deadline);
    if (diff !== 0) return diff;
  }
  // Lower priority order = more important; items without one go last
  const priorityA = a.priority ?? Infinity;
  const priorityB = b.priority ?? Infinity;
  if (priorityA !== priorityB) return priorityA - priorityB;
  return (a.title || "").localeCompare(b.title || "");
};

export const groupMyDayItems = (items = []) => {
  const groups = Object.fromEntries(MY_DAY_GROUPS.map((g) => [g.key, []]));
  items.forEach((item) => {
    const key = getGroupKey(item);
    if (key) groups[key].push(item);
  });
  Object.values(groups).forEach((group) => group.sort(compareItems));
  return groups;
};

// Pass t and the language from useTranslation()
export const formatMyDayDeadline = (deadline, t, language) => {
  if (!deadline) return t("time.noDeadline");
  const days = daysFromToday(deadline);
  if (days < 0) return t("time.daysOverdue", { count: Math.abs(days) });
  if (days === 0) return t("time.today");
  if (days === 1) return t("time.tomorrow");
  if (days <= 6) {
    return new Date(deadline).toLocaleDateString(language, { weekday: "long" });
  }
  return new Date(deadline).toLocaleDateString(language, {
    month: "short",
    day: "numeric",
  });
};
